import { render } from "./http-proxy.vue?vue&type=template&id=c084d65c"
import script from "./http-proxy.vue?vue&type=script&lang=js"
export * from "./http-proxy.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__